// Env flag — controla o comportamento de mostrar módulos bloqueados via upsell
// em vez de esconder. O default é desligado (false).
const FEATURE_ENABLED = import.meta.env.VITE_BLOCKED_MODULES_ENABLED === 'true';

// Debug — força TODO módulo com taskId a renderizar o upsell, ignorando country
// e o estado real de permissões do usuário. Útil pra testar visualmente.
const FORCE_ALL_BLOCKED = import.meta.env.VITE_FORCE_ALL_BLOCKED === 'true';

/**
 * Países nos quais a feature de upsell deve ser ativada.
 * Por enquanto restrita a clientes brasileiros — produto/comercial só validou
 * o discurso e os mocks para esse mercado.
 */
const SUPPORTED_COUNTRIES = new Set(['BR']);

export const isForceAllBlocked = (): boolean => FORCE_ALL_BLOCKED;

/**
 * Decide globalmente se a feature de "mostrar módulos bloqueados via upsell"
 * está ativa para o contexto atual. Combina:
 *   - debug FORCE_ALL_BLOCKED (sempre vence)
 *   - env flag VITE_BLOCKED_MODULES_ENABLED
 *   - país do usuário (apenas BR por enquanto)
 *
 * Função pura — o hook `useBlockedModule` chama isso passando o país do
 * `userSession`. Em testes ou helpers fora do React, dá pra chamar direto.
 */
export const computeBlockedModulesActive = (country?: string | null): boolean => {
  if (FORCE_ALL_BLOCKED) return true;
  if (!FEATURE_ENABLED) return false;
  return country != null && SUPPORTED_COUNTRIES.has(country);
};
